import { render, staticRenderFns } from "./ManageLineChannel.vue?vue&type=template&id=5ff25c64&scoped=true&"
import script from "./ManageLineChannel.vue?vue&type=script&lang=js&"
export * from "./ManageLineChannel.vue?vue&type=script&lang=js&"
import style0 from "./ManageLineChannel.vue?vue&type=style&index=0&id=5ff25c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff25c64",
  null
  
)

export default component.exports